import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11635724"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "purchase-order-material-select hmd-btn" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("加入材料库")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "加入材料库", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "点击确定会将右侧待选列表中的项目加入目标清单", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 使用相同材料分类 ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red mr5" }, "*", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所属分类", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_material_category_select = _resolveComponent("material-category-select")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, {
      type: "primary",
      onClick: _ctx.showModal
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
      keyboard: false,
      centered: true,
      "mask-closable": false,
      width: "90%",
      onOk: _ctx.ok,
      onCancel: _ctx.closeModal
    }, {
      title: _withCtx(() => [
        _hoisted_3,
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_search, {
                        class: "w300",
                        placeholder: "请输入材料名称关键字",
                        "enter-button": "",
                        onSearch: _ctx.onSearch
                      }, null, 8, ["onSearch"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.checked,
                        onChange: _ctx.onCheckChange
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }, 8, ["checked", "onChange"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_table, {
            "row-key": "uuid",
            size: "small",
            bordered: true,
            "data-source": _ctx.dataSource,
            columns: _ctx.columns,
            scroll: { x: true }
          }, {
            index: _withCtx(({ index }) => [
              _createTextVNode(_toDisplayString(index + 1), 1)
            ]),
            materialCategoryTitle: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            materialCategoryId: _withCtx(({ record, index }) => [
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_material_category_select, {
                    disabled: _ctx.checked && index > 0,
                    class: "w100",
                    value: record.materialCategoryId,
                    "onUpdate:value": ($event: any) => ((record.materialCategoryId) = $event),
                    onChange: (val) => _ctx.onCategoryChange(val, index)
                  }, null, 8, ["disabled", "value", "onUpdate:value", "onChange"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["data-source", "columns"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "onCancel"])
  ]))
}